module.exports = __webpack_public_path__ + "static/iphone-hostel-6d8b837f2c6d79c39de268d1ae72b1c7.png";